export { LoadingSpinner as default } from '@miniapp-core/ui-kit';
